<template>
  <PersonalAreaTemplate
    :editing="editing"
    :max-width="modal ? null : 888"
    :files="checkData.file"
    :delete-files="checkData.deleteFiles"
    maxFilesShow="9999999999"
    :fileAccept="['pdf']"
    :fileEditAccess="
      $userCheckAccess({
        abilities: 'remove_employees_contract',
      })
    "
    :on-save="onSave"
  >
    <v-form class="d-grid gap-5" ref="form" lazy-validation v-model="valid">
      <BaseInput
        type="switch"
        v-model="termless"
        :label="localStorage.translations.pages['setting-personal_area'].labels['termless']"
        @input="changeTerm"
        :disabled="
          !editing ||
          !$userCheckAccess({
            abilities: 'remove_employees_contract',
          })
        "
      />
      <BaseInput
        v-if="!termless"
        type="date-picker"
        :label="localStorage.translations.pages['setting-personal_area'].labels['srok-deystiviya']"
        :disabled="
          !editing ||
          !$userCheckAccess({
            abilities: 'remove_employees_contract',
          })
        "
        placeholder="–"
        v-model="checkData.dateEnd"
        clearable
        :rules="checkData.file.length ? ['required'] : null"
      />
    </v-form>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'
import BaseInput from 'components/base/BaseInput'

export default {
  name: 'Contract',
  props: { editing: Boolean, contract: Object, userId: Number, onSave: Function, modal: Boolean },
  components: {
    BaseInput,
    PersonalAreaTemplate,
  },
  data: () => ({
    valid: false,
    contractData: null,
    checkData: {
      dateEnd: null,
      file: [],
      deleteFiles: [],
    },
    termless: false,
  }),
  mounted() {
    this.onActualData()
  },
  watch: {
    contract() {
      this.onActualData()
    },
    checkData: {
      deep: true,
      handler() {
        if (this.editing) {
          this.onNavigationGuardianCheck({
            data: { contract: this.checkData },
            overwrite: false,
          })
        }
      },
    },
  },
  computed: {
    computedDateFormatted() {
      return this.$formatDate(this.checkData.dateEnd)
    },
    personalAreaUserEdit() {
      return this.$route.name === 'PersonalAreaEdit'
    },
  },
  methods: {
    ...mapActions('user', ['onUserCreateEmployeeDoc', 'onUserUpdateEmployeeDoc']),
    ...mapActions('employeeDoc', ['onCreateEmployeeDoc', 'onUpdateEmployeeDoc']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onActualData() {
      if (this.contract) {
        this.contractData = JSON.parse(this.contract.data)
        this.termless = this.contractData.date_end ? false : true
        this.checkData.dateEnd = this.contractData.date_end
        this.checkData.file = this.contractData.file || this.contractData.image
      }
      this.onNavigationGuardianCheck({
        data: { contract: this.checkData },
        overwrite: true,
      })
    },
    changeTerm() {
      if (this.termless) this.checkData.dateEnd = null
    },
    async deleteImageBD() {
      if (this.checkData.deleteFiles.length) {
        for (let i in this.checkData.deleteFiles) {
          this.$store.dispatch('deleteFile', {
            url: this.checkData.deleteFiles[i],
          })
        }
        this.checkData.deleteFiles = []
      }
    },
    validate() {
      this.$refs.form.validate()
    },
    async submitFile(file, i) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', file)
        this.$store
          .dispatch('uploadFile', {
            data: formData,
            use_case: undefined,
          })
          .then((response) => {
            this.checkData.file[i] = response.data.url
            return resolve(response)
          })
          .catch((err) => {
            this.checkData.file.splice(i, 1)
            return reject(err)
          })
      })
    },
    async saveChange() {
      return new Promise(async (resolve, reject) => {
        if (
          this.$userCheckAccess({
            abilities: ['add_employees_contract', 'edit_employees_contract'],
          })
        ) {
          if (this.$checkNavigationGuardianChange('contract')) {
            await Promise.all(
              this.checkData.file.map(async (file, index) => {
                if (typeof file !== 'string') {
                  await this.submitFile(file, index)
                }
              }),
            )
            await this.deleteImageBD()
            let data = {
              type: 'contract',
              data: JSON.stringify({
                date_end: this.checkData.dateEnd,
                file: this.checkData.file,
              }),
            }
            if (!this.contract || this.contract.data === null) {
              if (this.$route.name === 'PersonalAreaEmployeeEdit') {
                data.user_id = this.userId
              }
            } else {
              data.id = this.contract.id
            }
            resolve(data)
          } else resolve(true)
        } else {
          resolve(true)
        }
      })
    },
  },
}
</script>
